import {
  ADD_USER_TASK_REQUEST,
  ADD_USER_TASK_RESPONSE,
  DELETE_USER_TASK_REQUEST,
  DELETE_USER_TASK_RESPONSE,
  FETCH_TASKS_CIRCLES_RESPONSE,
  FETCH_USERS_TASKS_REQUEST,
  FETCH_USERS_TASKS_RESPONSE,
  SET_ACTIVE_TASK_REQUEST,
  SET_ACTIVE_TASK_RESPONSE,
  UPDATE_USER_TASK_REQUEST,
  UPDATE_USER_TASK_RESPONSE
} from '../constants/actionTypes';

export const fetchUsersTasksRequest = payload => ({
  type: FETCH_USERS_TASKS_REQUEST,
  payload
});

export const fetchUsersTasksResponse = payload => ({
  type: FETCH_USERS_TASKS_RESPONSE,
  payload
});

export const fetchTasksCirclesResponse = payload => ({
  type: FETCH_TASKS_CIRCLES_RESPONSE,
  payload
});

export const setActiveTaskRequest = payload => ({
  type: SET_ACTIVE_TASK_REQUEST,
  payload
});

export const setActiveTaskResponse = payload => ({
  type: SET_ACTIVE_TASK_RESPONSE,
  payload
});

export const addUserTaskRequest = payload => ({
  type: ADD_USER_TASK_REQUEST,
  payload
});

export const addUserTaskResponse = payload => ({
  type: ADD_USER_TASK_RESPONSE,
  payload
});

export const updateUserTaskRequst = payload => ({
  type: UPDATE_USER_TASK_REQUEST,
  payload
});

export const updateUserTaskResponse = payload => ({
  type: UPDATE_USER_TASK_RESPONSE,
  payload
});

export const deleteUserTaskRequest = payload => ({
  type: DELETE_USER_TASK_REQUEST,
  payload
});

export const deleteUserTaskResponse = payload => ({
  type: DELETE_USER_TASK_RESPONSE,
  payload
});
